import { render, staticRenderFns } from "./SysCheckRuleTestModal.vue?vue&type=template&id=13a46de1&scoped=true&"
import script from "./SysCheckRuleTestModal.vue?vue&type=script&lang=js&"
export * from "./SysCheckRuleTestModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a46de1",
  null
  
)

export default component.exports